export default __webpack_public_path__ + "static/media/TVinsure-Covid-2.8f024b6d.png";